/** localStorage key prefix for persisting the last-visited page per workspace */
export const LAST_PAGE_KEY_PREFIX = 'deckspace:lastPage:';
